<template>
  <div class="active-content" ref="activeContent">
    <!-- 文字轮播图 -->
    <!-- <marqueeText></marqueeText> -->

    <!-- <GameDetail></GameDetail> -->
    
     <!-- 悬浮导航栏 -->
    <TeamCol :team.sync="team" :offset="scrollTop + 50" />

    <!-- 轮播图 -->
    <BannerSection :team="team" ref="banner" />
    <!-- 官方视频 -->
    <VideoSection
      @play="playOfficial"
      :team="team"
      :list-data="newsList"
      @read="fetchNewsInfo"
    />
    <!-- 历史视屏前瞻 -->
    <transition name="fadeClose">
      <HistorySection
        @play="playHistory"
        @context="fetchContext"
        :list-data="historyGameList"
        :team="team"
        ref="history"
        v-if="historyGameList.length > 0"
      />
    </transition>
    <!-- 赞助商组件 -->
    <CooperatorSection :team="team" />
    <div class="module-4" v-if="videoDialog">
      <!-- 视频直播 -->

      <el-dialog
        :visible.sync="videoDialog"
        width="100%"
        :show-close="false"
        :before-close="handleClose"
      >
        <!-- <img class="video-close" src="../../assets/images/video-close.png" v-on:click.stop="videoDialog=false" alt=""> -->
        <video
          class="video-dialog-box"
          muted
          :src="videoUrl"
          autoplay
          center
          controls="controls"
          loop="loop"
          playsinline="true"
          webkit-playsinline="true"
          x5-video-player-type="h5"
        >
          <!-- <source :src="videoUrl" type="video/mp4" /> -->
          您的浏览器不支持 video 标签。
        </video>
      </el-dialog>

      <!-- 弹出层 -->
      <el-dialog
        :visible.sync="ruleDialog"
        width="100%"
        :show-close="false"
        top="50%"
        center
        :before-close="ruleDialogClose"
      >
        <div class="rule-dialog">
          <h1>
            {{ reportData.title }}
            <i class="el-icon-error" @click.self="ruleDialogClose"></i>
          </h1>
          <div>
            <div class="dialog-list">
              <div class="scroll-list">
                <ul>
                  <li
                    v-for="(item, index) in reportData.report"
                    :key="index"
                    :class="{ active: reportActiveIndex === index }"
                    @click.stop="reportActiveIndex = index"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="rule-info">
              <h3>
                {{
                  reportData.report &&
                  reportData.report[reportActiveIndex].title
                }}
              </h3>
              <div
                v-html="
                  reportData.report &&
                  reportData.report[reportActiveIndex].content
                "
              ></div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

   

    <!---------------------------->
    <input
      type="hidden"
      name="msn"
      maxlength="100"
      class="text"
      desc="用戶名"
      ref="hideValue"
    />
    <!---------------------------->
  </div>
</template>

<script>
import { JSEncrypt } from "jsencrypt";
import {
  getGameListByTeam,
  getContextOfGameById,
  getArticleListByRound,
  getNewsList,
  getNewsEntity,
} from "@/api/api";

import marqueeText from "@/components/marquee"; // 公告轮播
import { setInterval, clearInterval } from "timers";
import BannerSection from "@/components/section/banner";
import HistorySection from "@/components/section/history";
import VideoSection from "@/components/section/video";
import CooperatorSection from "@/components/section/cooperator";
import TeamCol from "@/components/section/teamCol";
import GameDetail from "@/components/items/GameDetail";
export default {
  name: "activeContent",

  data() {
    const that = this;
    return {
      team: "",
      scrollTop: 0,
      apiParams: {}, // 接口参数
      videoDialog: false, // 视频播放弹出层
      videoUrl: null, // 视频播放地址
      reportData: {}, // 赛事赛前分析及赛后复盘
      reportActiveIndex: 0,
      ruleDialog: false, // 赛事前瞻/赛后解盘
      historyGameList: [],
      newsList: [],
      eleCount: 0,
      isLoading: false,
    };
  },
   components: {
    marqueeText,
    BannerSection,
    HistorySection,
    VideoSection,
    CooperatorSection,
    TeamCol,
    GameDetail,
  },
  watch: {
    team(nv) {
      this.fetchSeasonlyTeamData(nv);
      this.fetchNews();
    },
  },
  created: function () {
    this.team = "wolves";
    // this.getData();
    this.fetchSeasonlyTeamData();
    this.getUrlParameter();
    this.$nextTick(() => {
      const _this = this;
      window.addEventListener("scroll", () => {
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        this.scrollTop = scrollTop;
      });
    });
    sessionStorage.clear(); // 刷新页面重新请求数据，否则将赛队数据储存到session中进行调用。_2019-8-9 17:23
  },
  computed: {
    swiper() {
      return (
        (this.$refs.history && this.$refs.history.$refs.roundSwiper.swiper) ||
        null
      );
    },
    mySwiper() {
      return (
        (this.$refs.banner && this.$refs.banner.$refs.mySwiper.swiper) || null
      );
    },
    teamIndex() {
      const team = this.team;
      const obj = {
        wolves: 3,
        australia_a_league: 5,
        serie_a: 4,
        la_liga: 2,
        premier_league: 1,
      };
      return obj[team] || 3;
    },
  },
  mounted() {},
  methods: {
    async fetchNews() {
      let res = await getNewsList(this.teamIndex);
      const { code, data } = res.data;
      if (code === 200) {
        this.newsList = data && data.data;
      }
    },
    async fetchNewsInfo({ id, summary }) {
      if (this.isLoading) return;
      this.isLoading = true;
      let res = await getNewsEntity(id);
      this.isLoading = false;
      const { code, data } = res.data;
      if (code === 200) {
        const ele = this.createArticleElement([{ id: 0, title: data.title }], {
          index: 0,
          title: null,
          summary: null, //summary,
          content: data.content,
        });
        this.openArticleDialog(ele);
      } else this.msgAlert("目前尚无资讯。");
    },
    async fetchContext(item) {
      if (this.isLoading) return;
      if (this.team !== "wolves") {
        this.isLoading = true;
        let _data = await getArticleListByRound(
          item.type,
          this.team,
          item.round
        );
        this.isLoading = false;
        const { code, msg, data } = _data.data;
        if (code !== 200 || !data || data.length === 0) {
          if (code !== 200) {
            this.msgAlert(msg);
          } else {
            this.msgAlert("目前尚无资讯。");
          }
        } else {
          data.forEach((e) => (e.type = item.type));
          const ele = this.createArticleElement([...data], null);
          this.openArticleDialog(ele);
        }
      } else {
        this.isLoading = true;
        getContextOfGameById(item.type, item.id).then((rv) => {
          const { code, msg, data } = rv.data;
          if (code === 200 && data) {
            if (data.content) {
              const h = this.$createElement;
              const ele = this.createArticleElement(
                [{ id: 0, title: data.title }],
                {
                  index: 0,
                  title: data.title,
                  content: data.content,
                }
              );
              this.openArticleDialog(ele);
            } else this.msgAlert("目前尚无资讯。");
          } else {
            this.msgAlert(msg);
          }
          this.isLoading = false;
        });
      }
    },
    openArticleDialog(ele) {
      const obj = this.$msgbox({
        title: "",
        message: ele,
        dangerouslyUseHTMLString: true,
        showClose: true,
        customClass: "sponser",
        onClose: (param) => {
          // console.log(param);
          setTimeout(() => {
            const dialogs = Array.prototype.slice.call(
              document.body.querySelectorAll(
                '.el-message-box__wrapper[role="dialog"][tabindex="-1"]'
              )
            );
            dialogs.forEach((e) => e.remove());
          }, 200);
        },
      });
    },
    createArticleElement(list, item) {
      const h = this.$createElement;
      const ele = h("GameDetail", {
        key: this.eleCount++,
        props: {
          list: [...list],
          item: item || {},
        },
      });
      console.log(item);
      return ele;
    },

    fetchSeasonlyTeamData() {
      getGameListByTeam(this.team).then((rv) => {
        const { code, msg, data } = rv.data || {};
        if (code === 200 && data) {
          this.historyGameList = data;
        } else {
          this.msgAlert(msg);
        }
      });
    },
    playHistory(url) {
      this.openVideo(url);
    },
    playOfficial() {
    
      const entry = require("../assets/video/" + this.team + "/official.mp4");
      this.openVideo(entry);
    },

    setCountly(eventName, key, value) {
      let params = {};
      params[key] = value;
      this.$Countly.q.push([
        "add_event",
        {
          key: eventName,
          segmentation: params,
        },
      ]);
    },
    handleClose() {
      const that = this;
      that.clearTimer();
      that.videoDialog = false;
    },
    clearTimer() {},
    handleScroll() {
      document.getElementById("top").scrollIntoView({
        behavior: "smooth",
      });
    },
    ruleDialogClose() {
      this.ruleDialog = false;
    },
    openVideo(url, index) {
      let path = url.split(".");
      let v = ["avi", "wma", "rmvb", "rm", "flash", "mp4", "mid", "3gp"];
      const type = path[path.length - 1];
      if (v.indexOf(type) < 0) {
        this.msgAlert("暂无相关视频，敬请期待！");
      } else {
        this.clearTimer();
        this.videoDialog = true;
        this.videoUrl = url;
      }
    },
    msgAlert(msg) {
      this.$alert(msg, "尊敬的用户您好");
    },

    // 获取会员用户名
    getUrlParameter() {
      let results = this.verifyPath("username") || this.verifyPath("userName");
      let flag = results ? decodeURIComponent(results[1]) : "";
      this.setUserName(flag, 0);
      if (!flag) this.getUserName();
    },
    verifyPath(key) {
      let regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
      let href = location.href || "";
      return regex.exec(href);
    },
    getUserName() {
      let timer = setInterval(() => {
        let _obj = (this.$refs.hideValue && this.$refs.hideValue.value) || "";
        // _obj = "yili007";
        if (_obj) {
          let jse = new JSEncrypt();
          jse.setPublicKey(
            "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhSazxfY8JCDU4Ihza5VII7Ku4NpAbtYn8MMcHQCGdc8nauWKOeLqMO6+nrex+eirwo9Ac4v2FXli3nbj3BaCENHVOUBeVJQbbplUeUS8quei+ihgoQMLkc8pLDOdYt+XeH30XeRxHfQNx2fx4yUdWVLbpwzuQIP8ACh8Lx3rNteMTAosNVnkBUQAkJ3zmuY2N01IxlBRwZpdxmJPmWafKfoF535UVKT+bV9Ce7LRzWB1dF2X9b2/ektKgLifQd9o6laGX79f9CshZ9u0nT3XDvHnCF3rKfLYDgNfkwcCrMWeuJ7EVMW4Mx5VjY0pY0mxFi+t6NA5rk/IAPDstI3W0QIDAQAB"
          );
          this.setUserName(jse.encrypt(_obj), 1);
          clearInterval(timer);
        }
      }, 1000);
    },
    // 根据传参方式进行设置
    setUserName(username = "", type = 0) {
      this.apiParams = {
        type: type,
        userName: username,
      };
    },
  },
 
  destroyed() {
    this.clearTimer();
    sessionStorage.clear();
    window.removeEventListener("scroll", this.handleScroll); // 离开页面 关闭监听 不然会报错
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/home";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="less">
@import "../styles/home";
.active-content {
  // margin-top: 1em;
  // padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue